export const RITUALS_STATES_LABELS = {
    Archived: 'Archivé',
    Created: 'Créé',
    Regular: 'Actif',
    Aborted: 'Aborted',
};
